export default __webpack_public_path__ + "static/media/send-icon.58a0bdb1.svg";